module.exports = __webpack_public_path__ + "img/img56.b1b66cbf.png";